import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface AttachmentDialogControllerTargetLifecycleHooks {
  public fun linkDialogTargetConnected(element: HTMLElement) {
  }

  public fun linkDialogTargetDisconnected(element: HTMLElement) {
  }

  public fun fileDialogTargetConnected(element: HTMLElement) {
  }

  public fun fileDialogTargetDisconnected(element: HTMLElement) {
  }
}

public fun <T : HTMLElement> AttachmentDialogController.linkDialogTarget(): StimulusProperty<T> =
    StimulusProperty("linkDialogTarget")

public fun <T : HTMLElement> AttachmentDialogController.linkDialogTargets():
    StimulusProperty<Array<T>> = StimulusProperty("linkDialogTargets")

public fun <T : HTMLElement> AttachmentDialogController.fileDialogTarget(): StimulusProperty<T> =
    StimulusProperty("fileDialogTarget")

public fun <T : HTMLElement> AttachmentDialogController.fileDialogTargets():
    StimulusProperty<Array<T>> = StimulusProperty("fileDialogTargets")

public fun registerAttachmentDialogController(stimulus: Application) {
               val clazz = AttachmentDialogController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("""[
  "linkDialog",
  "fileDialog",
  ]""")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          
                      ),
                      null
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "attachmentdialog"
              println("Registering controller attachmentdialog")

              stimulus.register(controllerName, factoryFunc)
}
